import {
  selectState,
  setDeleteInputModalOpen,
  selectInputForOperation,
} from "../input.slice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { deleteInput } from "../input.slice";
import { toast } from "react-toastify";

const DeleteInputModal = () => {
  const { deleteInputModalOpen } = useSelector(selectState);
  const input = useSelector(selectInputForOperation);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteInputModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      await dispatch(deleteInput(input.inputId));
      toast.success("Uspesno obrisan.");
      close();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deleteInputModalOpen}
      onClose={close}
      onClick={doDelete}
      title="Brisanje potrošnog materijala"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeći potrošni materijal:
        <br />
        <br />
        <b>{input?.item.name} ?</b>
      </p>
    </Modal>
  );
};

export default DeleteInputModal;
